import React, { useState } from 'react';
import { Form, Col } from 'react-bootstrap';
import { Selectize, Fieldset, FormSelect } from '~/components/FormControl';
import PropTypes from 'prop-types';
import { API_PREFIX } from '~/pages/CardSaga/UpgradeCard/upgradeCard.api';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import CardMaker from '~/components/CardMaker';
import isEmpty from 'lodash/isEmpty';
import { renderUpgradeCardFrontEdit } from './renderUpgradeCardFrontEdit';
import { useSelector } from 'react-redux';
import { isBlobUrl, blobUrlToFile } from '~/utils/helpers';
import CardBack from '~/components/CardMaker/components/CardBack';

function CardInformation({ values }) {
    const { cardMetaData, backSides, resetCount } = useFormTab();
    const { keywords, actions, powers } = cardMetaData;
    const [replacements, setReplacements] = useState(values.replacements);
    const { name, templateId } = values;
    const { templates } = useSelector((state) => state.cardSaga.upgradeCard);

    const setTemplate = (form, templateId) => {
        const selected = templates.find((item) => item.id == templateId);

        /**
         * @typedef {Object} CardTemplate
         * @property {int} id - template id.
         * @property {string} cardFrame - The URL of the card frame image (either a path or a Blob URL).
         * @property {string} cardBack - The URL of the card back image (either a path or a Blob URL).
         */

        /**
         * Clone the selected cat's template.
         * @type {CardTemplate}
         */

        if (isBlobUrl(selected.cardFrame)) {
            const templateCloned = { ...selected };

            blobUrlToFile(templateCloned.cardFrame).then((fileObj) => {
                form.setFieldValue('template.cardFrame', fileObj);
            });
        } else {
            form.setFieldValue('template.cardFrame', selected.cardFrame);
        }

        form.setFieldValue('template.id', selected.id);
    };

    return (
        <>
            <FormSelect
                name="templateId"
                options={templates || []}
                sm={3}
                className={'offset-sm-4'}
                onChangeValue={setTemplate}
            />
            <Fieldset sm={12}>
                <Fieldset.Legend>Card Maker</Fieldset.Legend>
                <CardMaker
                    apiPrefix={API_PREFIX}
                    values={values}
                    cardBackElement={
                        <CardBack
                            pictureName={backSides[0]}
                            pictureVal={backSides[0].split('.').reduce((a, b) => a[b], values)}
                            resetCount={resetCount}
                            id={backSides[0]}
                        />
                    }
                    renderCardFrontEdit={renderUpgradeCardFrontEdit(name, replacements, templateId, templates)}
                    iconOrCrop={'icon'}
                />
            </Fieldset>

            {!isEmpty(cardMetaData) && (
                <Form.Row>
                    <Selectize
                        sm="3"
                        name="keywords"
                        options={keywords ?? []}
                        note="* only published keywords are available for selection."
                    />
                    <Selectize
                        as={Col}
                        sm="4"
                        name="replacements"
                        options={[...actions, ...powers] || []}
                        setReplacements={setReplacements}
                        tooltip="Card to replace during upgrade phase."
                    />
                </Form.Row>
            )}
        </>
    );
}

CardInformation.propTypes = {
    values: PropTypes.object.isRequired,
};
export default CardInformation;
